import angular from 'angular';

import RwSocialMediaComponent from './rw-social-media-component';

export default angular
  .module('rw-social-media', [])
  .component('rwSocialMedia', new RwSocialMediaComponent())



// WEBPACK FOOTER //
// ./src/modules/utils/rw-social-media/rw-social-media-module.js